'use strict';

const { isEmpty, get, isArray, isObject, isNumber, isString, isBoolean } = require('lodash');

const $cache = {
    body: $('body'),
};

const isEmptyDatalayer = (datalayer) => {
    if (isArray(datalayer) && isEmpty(datalayer)) return true;

    return datalayer.every((item) => {
        if (isObject(item) && isEmpty(item)) {
            return true;
        }

        if (!item && item !== 0 && item !== '') {
            return true;
        }

        if (isNumber(item) || isString(item) || isBoolean(item)) {
            return true;
        }

        return false;
    });
};

$(() => {
    $cache.body.on('gtm:hook', (e, data) => {
        e.preventDefault();

        const { targetGtmEl, context, productId } = data;

        const url = window.gtmHookCallUrl;

        if (!isEmpty(url)) {
            $.ajax({
                url,
                method: 'POST',
                data: { context, productId },
                success: function (response) {
                    const { success, gtmEventHookPayload, event } = response;
                    if (success) {
                        targetGtmEl.attr('data-tracking-click-event', event);
                        targetGtmEl.attr('data-tracking-event-payload', JSON.stringify(gtmEventHookPayload));
                    }
                },
            });
        }
    });

    $cache.body.on('gtm:add:event', (e, response) => {
        const datalayer = get(response, 'datalayer', []);
        if (!isEmptyDatalayer(datalayer)) {
            datalayer.forEach((layer) => {
                window.dataLayer.push(layer);
            });
        }
    });

    $cache.body.on('click', '.plp-display-mode-btn', function () {
        const $this = $(this);
        const url = $this.closest('.switch-view-container').attr('data-url');
        const displayMode = $this.attr('data-plp-display-mode');

        if (url && displayMode) {
            $.ajax({
                url: url,
                type: 'post',
                data: { displayMode },
                success: function (data) {
                    if (data.success) {
                        $('.product-grid')
                            .find('.product-tile')
                            .each(function () {
                                const $tile = $(this);
                                const payload = $tile.attr('data-tracking-event-payload');
                                let parsedPayload = {};
                                try {
                                    parsedPayload = JSON.parse(payload);
                                } catch (error) {
                                    parsedPayload = {};
                                }

                                const updatedSearchEvent = parsedPayload.map((datalayerEvent) => {
                                    if (datalayerEvent.event === 'search_click_result') {
                                        return { ...datalayerEvent, displayMode };
                                    }
                                    return { ...datalayerEvent };
                                });
                                $tile.attr('data-tracking-event-payload', JSON.stringify(updatedSearchEvent));
                            });
                    }
                },
            });
        }
    });

    $cache.body.on('gtm:trigger:event', (e, details) => {
        e.preventDefault();

        const url = window.gtmTriggerEventUrl;

        if (!isEmpty(url)) {
            $.ajax({
                url,
                method: 'POST',
                data: {
                    eventDetails: JSON.stringify(details),
                },
                success: function (response) {
                    $cache.body.trigger('gtm:add:event', response);
                },
            });
        }
    });

    $cache.body.on('click', 'button[value="submit-shipping"]', function () {
        $cache.body.trigger('gtm:trigger:event', {
            eventId: $(this).attr('data-event'),
        });
    });

    $cache.body.on('gtm:update:event', (e, { response, target }) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const dlItems = get(response, 'datalayerItems', {});

        const $targer = $(target);
        $targer.find('[data-tracking-event-payload]:not(.product-tile-pd)').each(function () {
            const $el = $(this);
            const payloadStr = $el.attr('data-tracking-event-payload');
            let payload = {};
            try {
                payload = JSON.parse(payloadStr);
            } catch (error) {
                payload = {};
            }

            const items = get(payload, 'ecommerce.items', []);

            if (items.length === 1) {
                const updatedItems = [dlItems];
                const updatedPayload = { ...payload, ecommerce: { ...payload.ecommerce, items: updatedItems } };
                $el.attr('data-tracking-event-payload', JSON.stringify(updatedPayload));
            }
        });
    });
});

/**
 * @typedef {import('jquery')} jQuery
 */

/**
 * Detects all current and future Slick Carousel instances on the page
 * as they are initialized. It fires a callback for each detected slider.
 * This function uses a MutationObserver to efficiently detect dynamically added sliders.
 *
 * @param {Array} callbacks - A function to be executed for each
 * detected slick slider. The slider's jQuery element is passed as the first argument.
 */
const onSlickInit = (() => {
    const SLICK_CLASS = '.slick-initialized';
    const callbacks = [];

    const runCallbacks = (el) => {
        callbacks.forEach((cb) => cb(el));
    };

    const processSlickElements = (context) => {
        $(context)
            .find(SLICK_CLASS)
            .addBack(SLICK_CLASS)
            .each(function () {
                runCallbacks($(this));
            });
    };

    $(() => {
        processSlickElements(document.body);
    });

    const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    processSlickElements(node);
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    // Return function to register one or multiple callbacks
    return (...cbs) => {
        cbs.forEach((cb) => {
            if (typeof cb === 'function') {
                callbacks.push(cb);
            }
        });
    };
})();

/**
 * This function will insert gtm events generated by hook to slider controls
 *
 * @param {jQuery} $slider - The jQuery object for the detected slider.
 */
const handleNewSlider = ($slider) => {
    let $currentSliderWithData = $slider;
    if (!$currentSliderWithData.attr('data-tracking-event-payload')) {
        $currentSliderWithData = $slider.parent();
    }

    let isUpdated = false;
    const sliderClickEvent = $currentSliderWithData.attr('data-tracking-click-event');
    const sliderClickPayload = $currentSliderWithData.attr('data-tracking-event-payload');
    const sliderClickLevel = $currentSliderWithData.attr('data-tracking-event-level');

    if (!isEmpty(sliderClickEvent) && !isEmpty(sliderClickPayload)) {
        $slider.find('.slick-arrow').each((_, arrow) => {
            $(arrow).attr('data-tracking-click-event', sliderClickEvent);
            $(arrow).attr('data-tracking-event-payload', sliderClickPayload);
            $(arrow).attr('data-tracking-event-level', sliderClickLevel);
            isUpdated = true;
        });
        if (isUpdated) {
            $slider.removeAttr('data-tracking-click-event');
            $slider.removeAttr('data-tracking-event-payload');
            $slider.removeAttr('data-tracking-event-level');
            if (!$slider.is($currentSliderWithData)) {
                $currentSliderWithData.removeAttr('data-tracking-click-event');
                $currentSliderWithData.removeAttr('data-tracking-event-payload');
                $currentSliderWithData.removeAttr('data-tracking-event-level');
            }
        }
    }
};

/**
 * Injects the index of each carousel item into the `data-xyz` attribute
 * of its nested elements
 *
 * - Only processes `.slick-slide` elements that are **not** `.slick-cloned`.
 * - Parses the `data` value as JSON, adds an `index` property,
 *   and writes it back to the element.
 *
 * @param {jQuery} slider - The jQuery object representing the `.slick-initialized` slider element.
 */
function injectIndexIntoItems(slider) {
    const originals = slider.find('.slick-slide:not(.slick-cloned)');
    const realSlideCount = originals.length;

    originals.each(function () {
        const item = $(this);
        const slickIndex = parseInt(item.attr('data-slick-index'), 10);

        item.find('[data-tracking-event-payload]').each(function () {
            const el = $(this);
            let data = {};
            try {
                data = JSON.parse(el.attr('data-tracking-event-payload'));
            } catch (e) {
                data = {};
            }

            const productItem = get(data, 'ecommerce.items', [])[0];
            if (productItem) {
                productItem.index = slickIndex;
                const updatedDl = {
                    ...data,
                    ecommerce: { ...data.ecommerce, items: [productItem] },
                };
                el.attr('data-tracking-event-payload', JSON.stringify(updatedDl));
            }
        });
    });

    // Now update cloned slides (impacts inifinite scrolling)
    slider.find('.slick-slide.slick-cloned').each(function () {
        const clone = $(this);
        const slickIndex = parseInt(clone.attr('data-slick-index'), 10);
        const normalizedIndex = ((slickIndex % realSlideCount) + realSlideCount) % realSlideCount;

        const original = originals.eq(normalizedIndex);
        const payload = original.find('[data-tracking-event-payload]').attr('data-tracking-event-payload');

        if (payload) {
            clone.find('[data-tracking-event-payload]').attr('data-tracking-event-payload', payload);
        }
    });
}

onSlickInit(handleNewSlider, injectIndexIntoItems);
